import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "header-title"
}
const _hoisted_3 = { class: "infos" }
const _hoisted_4 = { class: "code" }
const _hoisted_5 = {
  key: 0,
  class: "company"
}
const _hoisted_6 = { class: "header-actions" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "evaluation" }

import { onMounted, ref, Component } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import type {
  EvaluationType,
  EvaluationListType,
} from "@/common/types/evaluation";

import { PanelTheme } from "../";

import {
  baseInput,
  baseConfirm,
  baseAvatar,
  svgIcon,
  tabMenu,
  iconMenu,
  cardEvaluation,
} from "@/common/components";

interface TabListType {
  [key: string]: {
    key: string;
    icon: string;
    label: string;
    component: Component;
    props?: any;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'evaluation',
  props: {
    accountId: {},
    evaluationId: {},
    evaluation: {},
    evaluations: {},
    tabList: {},
    menuList: {},
    isEdit: { type: Boolean }
  },
  emits: [
  "update-data",
  "add",
  "input-search",
  "search",
  "select-tab",
],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const router = useRouter();

const emit = __emit;

const props = __props;

const selectedTab = ref<string | null>(null);

function selectTab(tab: string) {
  selectedTab.value = tab;
}

function back() {
  router.push(`/${props.accountId}/evaluate`);
}

onMounted(() => {
  selectTab("info");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.evaluation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(baseAvatar), {
                size: "1.5em",
                url: __props.evaluation.company?.avatar?.small
              }, null, 8, ["url"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.evaluation.code), 1),
                (__props.evaluation.company)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.evaluation.company?.name), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-back h-8 w-8 p-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1.25rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(tabMenu), {
            tabs: __props.menuList,
            active: selectedTab.value,
            "onSelect:tab": _cache[2] || (_cache[2] = ($event: any) => (selectTab($event)))
          }, {
            content: _withCtx(() => [
              (selectedTab.value)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tabList[selectedTab.value]?.component), _mergeProps({ key: 0 }, __props.tabList[selectedTab.value]?.props, {
                    "is-edit": __props.isEdit,
                    "account-id": __props.accountId,
                    "evaluation-id": __props.evaluation?.evaluation_id,
                    data: __props.evaluation,
                    onUpdateData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-data')))
                  }), null, 16, ["is-edit", "account-id", "evaluation-id", "data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["tabs", "active"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})